import React, { useRef, useState } from 'react';
import clockIcon from '../../../_assets/sass/pages/chatbot/clock.svg';
import tickIcon from '../../../_assets/sass/pages/chatbot/tick.svg';
import dtickIcon from '../../../_assets/sass/pages/chatbot/doubleticks.svg';


const HorizontalMenu  = (props) => {
const { msg, items, recipient, sendMessage} = props;
const scrollRef = useRef(null);
const [isDragging, setIsDragging] = useState(false);
const [startX, setStartX] = useState(0);
const [scrollLeft, setScrollLeft] = useState(0);

const handleMouseDown = (e) => {
    setIsDragging(true);
    const slider = scrollRef.current;
    if (slider) {
        setStartX(e.pageX - slider.offsetLeft);
        setScrollLeft(slider.scrollLeft);
        slider.style.cursor = 'grabbing';
        slider.style.userSelect = 'none';
    }
};

const handleMouseUp = () => {
    setIsDragging(false);
    const slider = scrollRef.current;
    if (slider) {
        slider.style.cursor = 'grab';
        slider.style.userSelect = 'auto';
    }
};

const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const slider = scrollRef.current;
    if (slider) {
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
    }
};


const getStatusIcon = () => {
        if (!msg.isMe) return null; 
        
        switch (msg.status) {
            case 1:
                return <img src={clockIcon}  />;
            case 2:
                return <img src={tickIcon} />;
            case 3:
                return <img src={dtickIcon} />;
            default:
                return null;
        }
    };
 


    return (
        
        <div className="menu-container">
            <div className="menu-wrapper" ref={scrollRef}
             onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseUp} // Optional: Reset on mouse leaving the container
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
            >
                {items.map((item, index) => (
                <button 
                    key={index} 
                    className="menu-item"
                    onClick={() => sendMessage(recipient, item)} 
                >
                    {item}
                </button>
                ))}
            </div>
             {/* {getStatusIcon()} */}
            </div>
    );
};

export default HorizontalMenu;